<template>
  <div id="card-volume">
    <div class="flex-1 mx-1" @click="onClick">
      <vs-card actionable class="cardx">
        <p class="h7">{{ name }}</p>
        <h5
          class="mt-1 flex"
          :class="[{ primary: isActive }, loading ? 'justifyCenter' : '']"
        >
          <half-circle-spinner
            v-if="loading"
            :animation-duration="1000"
            :size="20"
            color="#000000"
          />
          <div v-else>
            <vs-icon :icon="icon" />
            {{ volume }} {{ unit }}
          </div>
        </h5>
      </vs-card>
    </div>
  </div>
</template>

<script>
import { HalfCircleSpinner } from "epic-spinners";
import _ from "lodash";
export default {
  name: "cardVolume",
  components: {
    HalfCircleSpinner,
  },
  props: {
    name: {
      type: String,
      default: "",
    },
    refineryName: {
      type: String,
      default: "",
    },
    refineryID: {
      type: String || Number,
      default: "",
    },
    callback: {
      type: Function,
      default: () => {},
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    volume: {
      type: String || Number,
      default: "0",
    },
    unit: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "opacity",
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  watch: {
    // isLoading(val, oldval) {
    //   let count = 0;
    //   if (oldval && !_.isEqual(val, oldval)) {
    //     count = 200;
    //   }
    //   this.handlerLoading(val, count);
    // },
  },
  methods: {
    onClick() {
      this.callback(this.refineryName, this.refineryID);
    },
    handlerLoading(loading, count = 0) {
      const vm = this;
      setTimeout(() => {
        vm.loading = loading;
      }, count);
    }, 
  },
};
</script>

<style>
.justifyCenter {
  justify-content: center;
  justify-items: center;
}
</style>